import React from "react";
import {
  Dialog,
  Box,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import inProgress from "../../../assets/Done.svg";

const ModalDispatched = ({ open, onClose, onConfirm, loading }) => {
  const handleConfirmClick = async () => {
    await onConfirm();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 460,
          borderRadius: 3,
          overflow: "hidden",
          p: 0,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          pb: 0.5,
          pt: 2.5,
          px: 3,
        }}
      >
        <Typography variant="h6" fontWeight={700} color="text.primary">
          Confirmar despacho
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: "text.secondary", mt: -0.5 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 3, pt: 1, pb: 2, textAlign: "center" }}>
        <Box
          component="img"
          src={inProgress}
          alt="Despacho"
          sx={{
            width: 220,
            height: "auto",
            maxHeight: 180,
            my: 2,
            objectFit: "contain",
          }}
        />
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          ¿Confirmas que el pedido fue despachado?
        </Typography>
      </DialogContent>

      <Divider />

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 1.5,
          px: 3,
          py: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={loading}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            borderColor: "#cbd5e1",
            color: "#475569",
            "&:hover": {
              borderColor: "#94a3b8",
              backgroundColor: "#f8fafc",
            },
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirmClick}
          color="primary"
          disabled={loading}
          startIcon={!loading && <CheckCircleOutlineIcon />}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
          }}
        >
          {loading ? "Confirmando..." : "Confirmar despacho"}
        </Button>
      </Box>
    </Dialog>
  );
};

export default ModalDispatched;
